module.exports = __webpack_public_path__ + "static/media/f01_2.6b6be857.png";